module.exports = __webpack_public_path__ + "static/img/active_btn.94c78a93.png";